import { render, staticRenderFns } from "./ProformaForm.vue?vue&type=template&id=8fea1e12&"
import script from "./ProformaForm.vue?vue&type=script&lang=js&"
export * from "./ProformaForm.vue?vue&type=script&lang=js&"
import style0 from "./ProformaForm.vue?vue&type=style&index=0&id=8fea1e12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports